import { Country, UniverseReference } from '@front/common/src/types/commons';
import { getCurrentCountry } from '@front/common/src/utils/country';

export type StepConfig = {
  shouldShowProgressBar: boolean;
};

export type SignupStep =
  | 'revenue_simulator'
  | 'register'
  | 'pro_status'
  | 'additional_information'
  | 'appointment'
  | 'confirmation'
  | 'not_qualified';

const stepperConfig: Partial<Record<SignupStep, StepConfig>> = {
  revenue_simulator: {
    shouldShowProgressBar: false,
  },
  register: {
    shouldShowProgressBar: true,
  },
  pro_status: {
    shouldShowProgressBar: true,
  },
  additional_information: {
    shouldShowProgressBar: true,
  },
  appointment: {
    shouldShowProgressBar: true,
  },
};

type UseSignupStepper = {
  shouldShowRevenueSimulator?: boolean;
  currentStep: SignupStep;
  universe: UniverseReference;
};

type StepsByUniverse = Record<UniverseReference, SignupStep[]>;
type StepsObject = Record<Country, StepsByUniverse>;
const STEPS_BY_COUNTRY_AND_UNIVERSE: StepsObject = {
  FR: {
    cleaning: ['revenue_simulator', 'register', 'pro_status', 'additional_information', 'appointment'],
    childcare: ['revenue_simulator', 'register', 'pro_status', 'additional_information'],
    beauty: ['register', 'pro_status', 'additional_information'],
    massage: ['register', 'pro_status', 'additional_information'],
    haircut: ['register', 'pro_status', 'additional_information'],
    sports_coaching: ['register', 'pro_status', 'additional_information'],
  },
  GB: {
    cleaning: ['revenue_simulator', 'register', 'pro_status', 'additional_information', 'appointment'],
    childcare: ['revenue_simulator', 'register', 'pro_status', 'additional_information'],
    beauty: ['register', 'pro_status', 'additional_information'],
    massage: ['register', 'pro_status', 'additional_information'],
    haircut: ['register', 'pro_status', 'additional_information'],
    sports_coaching: ['register', 'pro_status', 'additional_information'],
  },
};

export const useSignupStepper = ({ shouldShowRevenueSimulator = false, currentStep, universe }: UseSignupStepper) => {
  const STEPS: SignupStep[] = STEPS_BY_COUNTRY_AND_UNIVERSE[getCurrentCountry()][universe];
  const FILTERED_STEPS = STEPS.filter((step) => !(step === 'revenue_simulator' && !shouldShowRevenueSimulator));

  const currentIndex = FILTERED_STEPS.findIndex((step) => step === currentStep);
  const nextIndex = currentIndex + 1;
  const previousIndex = currentIndex - 1;

  return {
    currentIndex,
    total: FILTERED_STEPS.length,
    nextStep: FILTERED_STEPS[nextIndex],
    previousStep: FILTERED_STEPS[previousIndex],
    stepConfig: stepperConfig[FILTERED_STEPS[currentIndex]],
  };
};
